export var COLOR = 'Color';
export var GRADIENT = 'Gradient';
export var PATTERN = 'Pattern';
